export const state = () => ({
	invitations: []
})

export const mutations = {
	setInvitations(state, invitations) {
		state.invitations = invitations
	}
}

export const actions = {
	async fetch({ commit }, jobOfferId) {
		const response = await this.$axios.$get(
			`/job-offer/${jobOfferId}/assessment-invitations`,
			{ __skipGlobalErrorToast: true }
		)
		const invitations = response?.data || []
		commit('setInvitations', invitations)
		return invitations
	},

	async send({ commit }, { jobOfferId, emails }) {
		const response = await this.$axios.$post(
			`/job-offer/${jobOfferId}/assessment-invitations`,
			{ emails },
			{ __skipGlobalErrorToast: true }
		)
		const invitations = response?.data || []
		commit('setInvitations', invitations)
		return invitations
	}
}
